import { FGStack, FGTile, FGTypography, FGIcons, FGStackItem } from '@fg/design-system';
import { IActiveCountryMap } from 'interfaces';
import { map, isEmpty } from 'lodash/fp';
import { inject } from 'mobx-react';
import rootStore, { IMobxRootState } from '../../RootStore';
import GQFlag from 'components/GQFlag';

type MultiCountryPickerPreviewProps = {
    selectedCountries?: number[];
    allCountries?: IActiveCountryMap;
    onCountryClick?: (countryId: number) => void;
};

export const MultiCountryPickerPreview = inject(
    ({ countryStore }: IMobxRootState) => {
        return {
            allCountries: countryStore.countries.allCountries,
        };
    }
)((props: MultiCountryPickerPreviewProps) => {
    const { selectedCountries, allCountries, onCountryClick } = props;

    if (isEmpty(selectedCountries)) {
        return (
            <FGTypography tag="label" variant="label2" color="neutral">
                Countries
            </FGTypography>
        );
    }

    return (
        <FGStack
            direction="row"
            alignItems="center"
            gap={4}
            style={{
                flexWrap: 'wrap',
                maxHeight: 150,
                overflowY: 'auto',
            }}>
            {map((countryId: number) => {
                const country = allCountries[countryId];
                return (
                    <div
                        key={countryId}
                        onClick={(e) => {
                            e.stopPropagation();
                            onCountryClick?.(countryId)
                        }}
                        style={{ cursor: 'pointer' }}>
                        <FGTile
                            padding="small"
                            appearance="primary"
                            key={countryId}
                            style={{
                                width: 'auto',
                                pointerEvents: 'none',
                            }}>
                            <FGStack alignItems="center" gap={2}>
                                <FGStackItem>
                                    <FGStack alignItems="center" gap={0}>
                                        <GQFlag countryId={country.id} />
                                        <FGTypography
                                            tag="label"
                                            variant="label3">
                                            {country.name}
                                        </FGTypography>
                                    </FGStack>
                                </FGStackItem>
                                <FGStackItem>
                                    <FGStack alignItems="center" gap={0}>
                                        <FGIcons icon="Close" />
                                    </FGStack>
                                </FGStackItem>
                            </FGStack>
                        </FGTile>
                    </div>
                );
            }, selectedCountries || rootStore.countryStore.currentCountryList)}
        </FGStack>
    );
});
